<header class="mobile-header">
  <div class="header-content">
    <div class="header-toggle">
      @if (canGoBack()) {
        <button mat-icon-button (click)="goBack()" aria-label="Volver" class="back-button">
          <mat-icon class="material-symbols-rounded outline">arrow_back_ios</mat-icon>
        </button>
      } @else {
        <button mat-icon-button [matMenuTriggerFor]="userMenu" aria-label="Menú de usuario" class="menu-button">
          <mat-icon class="material-symbols-rounded outline">dehaze</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item (click)="changePassword()">
            <mat-icon class="material-symbols-rounded outline">lock</mat-icon>
            <span>{{ 'auth.buttons.changePassword' | translate }}</span>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon class="material-symbols-rounded outline">logout</mat-icon>
            <span>{{ 'auth.buttons.logout' | translate }}</span>
          </button>
        </mat-menu>
      }
    </div>

    <div class="header-title">
      <h5 class="app-title">{{ getPageTitle() }}</h5>
    </div>

    <!-- Botón de acción - Solo cuando NO hay botón de retroceso -->
    @if (!canGoBack()) {
      <div class="header-action">
        <button mat-raised-button color="primary" (click)="createRequest()" class="create-button button-text">
          {{ 'pqrs.buttons.createRequest' | translate }}
        </button>
      </div>
    }
  </div>
</header>
